require('./footer.js');

class Layout {
	constructor() {
		this.$container = $('body');
		this.$arMovingEls = this.$container.find('[data-layout-move]');
	}

	movingEls(element) {
		let $targetEl = this.$container.find($(element).data('layout-move'));
		let $element = $(element).detach();
		$element
			.appendTo($targetEl);
	}

	init() {
		if (this.$arMovingEls.length) {
			this.$arMovingEls.each((i, el) => {
				this.movingEls(el);
			});
		}
	}
}

let layout = new Layout();
layout.init();


//
// MOVE BLOCKs
//

$.fn.responsiveDom = function (options) {
	// The settings object provides default settings.
	// The options argument can override them.
	var settings = $.extend({
		appendTo: null,               // The element will be appended here
		prependTo: null,              // (or prepended here)...
		mediaQuery: '(min-width: 0)', // ...when this media query is true.
		callback: null                // If provided, the callback will run after DOM updates.
	}, options);

	var sourceEl = this;
	var placeholder = null;
	var isMoved = false;

	/**
	 * Initializes the plugin
	 */
	var init = function() {
		// Update the DOM now...
		updateDom();

		// ...and again when the window resizes
		$(window).on('resize.responsiveDom', debounce(updateDom, 100));
	};

	/**
	 * Moves or reverts element DOM position if the media query conditions are met
	 */
	var updateDom = function() {
		// Check if media query conditions are met
		if (!isMoved && matchMedia(settings.mediaQuery).matches) {
			moveElement();
			isMoved = true;
		} else if (isMoved && !matchMedia(settings.mediaQuery).matches) {
			revertElement();
			isMoved = false;
		} else {
			return;
		}

		// Run callback function if provided
		if (typeof settings.callback === 'function') {
			settings.callback(isMoved);
		}
	};

	/**
	 * Creates a placeholder at the element's current DOM position and moves the
	 * element to its new position
	 */
	var moveElement = function() {
		// Verify the source element still exists in the DOM
		if (!document.contains || document.contains(sourceEl[0])) {
			// Create placeholder so we can move it back if needed
			placeholder = $('<span class="js-responsive-dom-placeholder"/>');
			sourceEl.after(placeholder);

			// Check if Append or Prepend
			if(settings.appendTo !== null) {
				// Move element
				$(settings.appendTo).eq(0).append(sourceEl);
			} else {
				// Move element
				$(settings.prependTo).eq(0).prepend(sourceEl);
			}
		}
	};

	/**
	 * Returns element to its previous position in the DOM and removes the
	 * placeholder element
	 */
	var revertElement = function() {
		// Verify the placeholder still exists in the DOM
		if (placeholder !== null && (!document.contains || document.contains(placeholder[0]))) {
			// Move element back and remove placeholder
			placeholder.after(sourceEl);

			placeholder.remove();
			placeholder = null;
		}
	};

	/**
	 * Returns a function that cannot be called in succession unless a specified
	 * amount of time has passed
	 * @param func - The function to debounce
	 * @param wait - The wait time (ms) before running the function again
	 * @returns The debounced function
	 */
	var debounce = function(func, wait) {
		var timeout;

		return function() {
			clearTimeout(timeout);

			timeout = setTimeout(function() {
				func();
			}, wait);
		};
	};

	// Let's go!
	init();

	// Always return the target object to allow chaining.
	return this;
};

var breakpoints = {
	'v-mobile': '480px',
	'mobile': '768px',
	'tablet': '1024px',
	'default': '1240px'
}
var $moveBlock = $('.js-move-block');

$moveBlock.each(function(index){
	var $el = $(this),
			elMoveTarget = $el.data('target'),
			elMovePoint = $el.data('breakpoint');

	$el.responsiveDom({
		appendTo: '[data-id=' + elMoveTarget + ']',
		mediaQuery: '(max-width: ' + breakpoints[elMovePoint] + ')'
	})
});


//
// end MOVE BLOCKs
//



// WEBPACK FOOTER //
// ./frontend/components/layout/layout.js